import styled from 'styled-components'
import { GRAY_LIGHTEST } from '../../theme/colors'

import Popover from 'antd/lib/popover'
import * as React from 'react'

const MyPopover = ({ className, ...props }) => <Popover {...props} overlayClassName={className} />

export const Container = styled.div`
  position: relative;
  justify-content: center;
  &:hover {
    cursor: pointer;
    box-shadow: 1px 2px 6px -1px #dadada;
  }

  @media (min-width: 1440px) {
    min-width: 184px;
    max-width: 186px;
  }

  @media (max-width: 767px) {
    margin: 0;
    min-height: 268px;
  }
`

export const DesignPopover = styled(MyPopover)`
  .ant-popover-inner-content {
    padding: 4px 6px;
  }
  .ant-popover-arrow {
    display: none;
  }
  @media (max-width: 768px) {
    display: none;
  }
`

export const Image = styled.img`
  object-fit: cover;
  height: 400px;
  width: 360px;
  padding: 2px;
  background: ${GRAY_LIGHTEST};
  transition: all .25s;
  @media (max-width: 698px) {

  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const MediaImage = styled.img`
  width: 190px;
  height: 186px;
  border: 1px solid #e8e8e8;
  border-radius: 7px;
  object-fit: cover;
  padding: 0;
  @media (min-width: 1440px) {
    width: 186px;
    height: 296px;
  }
  @media (max-width: 768px) {
    min-width: 170px;
    min-height: 264px;
  }
  @media (min-width: 769px) {
    min-width: 170px;
    min-height: 274px;
  }
`

export const VideoPreview = styled.video<{preview?: boolean}>`
  object-fit: cover;
  width: 100%;
  max-width: ${props => props.preview ? '1024px' : '184px'};
  height: ${props => props.preview ? '90vh' : '298px'};
  max-height: 1664px;
  border: 1px solid #e8e8e8;
  border-radius: 7px;
  overflow: hidden;
  @media (max-width: 768px) {
    height: 264px;
    width: auto;
    max-width: 168px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AdComponent/styledComponents.tsx